import { createApp } from 'vue'
import App from './App.vue'

// 导入路由
import router from './router'

import Layui from '@layui/layui-vue'
import '@layui/layui-vue/lib/index.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'   // 注意这里是 bootstrap-vue-3 的样式


import { BootstrapVue3 } from 'bootstrap-vue-3'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import configPlugin from '@/plugins/config'

library.add(fas, far)

// 创建应用实例
const app = createApp(App)

// 异步初始化配置
async function initializeApp() {
  try {
    // 先使用配置插件并等待配置加载完成
    await configPlugin.install(app)

    // 然后使用其他插件
    app.use(router)
    app.use(Layui)
    app.use(BootstrapVue3)
    // app.use(ElementPlus)
    // 配置 Element Plus 使用中文
    app.use(ElementPlus, {
      locale: zhCn,
    })
    app.component('font-awesome-icon', FontAwesomeIcon)

    // 最后挂载应用
    app.mount('#app')

    // console.log('应用初始化完成')
  } catch (error) {
    console.error('应用初始化失败:', error)
  }
}

// 启动应用
initializeApp()